<template>
  <div>
    <form @submit.prevent="save">
      <input class="form-control" v-model="clientMinVersion" required>
      <b-button type="submit" variant="primary">Save</b-button>
    </form>
  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';

export default {
  name: 'GvntEditClientMinVersion',

  props: {
    gvntId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      clientMinVersion: '',
    };
  },

  computed: {
  },

  created() {
  },

  methods: {
    save() {
      const data = new FormData();

      const trimmedClientMinVersion = this.clientMinVersion.trim();
      data.set('client_min_version', trimmedClientMinVersion);

      const url = `/gvnt/${this.gvntId}/client_min_version`;
      HTTP.post(url, data)
      .then(response => {
        const resultCode = response.data.result.code;

        const RESULT_SUCCESS = 1;
        if(resultCode === RESULT_SUCCESS) {
          notifier.showSuccessAfterTransition('Client min version changed.');
          this.$router.push({name: 'gvnt_info'});
          return;
        }

        notifier.showError(`Unknown result code ${resultCode}.`, {sender: this});
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
